import { render, staticRenderFns } from "./UserExpense.vue?vue&type=template&id=e834f47e&lang=pug"
import script from "./UserExpense.vue?vue&type=script&lang=js"
export * from "./UserExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports